/** Browser stub for Node's `stream`. xlsx-js-style probes `stream.Readable` at load. */
export const Readable = undefined;
export default { Readable: undefined };
